<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">User Details</div>
        <div>
          <bread-crumb
            :bread-crumbs="['Partner Summary', 'Partner Branch', 'User Detail']"
          />
        </div>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="dessertHeaders"
        :items="desserts"
        dense
        item-key="name"
      >
        <template v-slot:item.UserID="{ item }">
          <a
            class="text-decoration-underline"
            @click="editBranch()"
            :title="item.Mainbranch"
          >
            {{ item.UserID }}
          </a>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-switch hide-details height="0px" color="primary"> </v-switch>
          <v-icon small color="primary" @click="deleteItem(item)"> </v-icon>
        </template>
        <template v-slot:[`item.actionss`]="{ item }">
          <v-icon small color="primary" @click="deleteItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-row class="mt-3">
            <v-col cols="12">
              <v-btn depressed 
                small
                color="primary"
                class="text-decoration-none text-capitalize ms-3 me-3"
                to="/partner-setup/summary/newUser"
                >New</v-btn
              >
              <v-btn depressed  @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Search"
                hide-details
                class="me-4 mb-3"
                dense
                clearable
              ></v-text-field
            ></v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"User Detail",
  data() {
    return {
      search: "",
      dessertHeaders: [
        {
          text: "User ID",
          align: "start",
          sortable: false,
          value: "UserID",
        },
        { text: "Login ID", value: "LoginID" },
        { text: "Access Code", value: "AccessCode" },
        { text: "User type", value: "Usertype" },
        { text: "Last login", value: "Lastlogin" },
        { text: "Delete", value: "actionss" },
        { text: "Is Active", value: "actions" },
      ],
      desserts: [
        {
          UserID: "10000006",
          LoginID: "test01",
          AccessCode: "AGRANI",
          Usertype: "Main branch",
          Lastlogin: "",
        },
      ],
      editBranch() {
        this.$router.push({ name: "Main Branch" });
      },
    };
  },
  components: {
    BreadCrumb,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
